import { createContext } from "preact";
import { ReceiptServiceInterface } from '@authentic/loyalty-pwa/interfaces/receipt.service.interface';

export const ReceiptServiceContext = createContext<ReceiptServiceInterface | null>(null)
